import { Link } from "react-router-dom";
import HeroCarousel from "./components/HeroCarousel";
import HotTagCloud from "./components/HotTagCloud";
import SiteIntroBanner from "./components/SiteIntroBanner";
import SectionHeading from "@/components/feature/SectionHeading";
import FilmCard from "@/components/feature/FilmCard";
import TopicCard from "@/components/feature/TopicCard";
import { films } from "@/mocks/films";
import { stars } from "@/mocks/stars";
import { topics } from "@/mocks/topics";
import { siteStats } from "@/mocks/home";
import { getStarFilms } from "@/lib/content";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function Home() {
  useDocumentMeta({
    title: "巨乳娱乐资讯网－影视人物及话题聚合平台",
    description:
      "巨乳娱乐资讯网提供丰富的影视作品、明星人物及网络话题资讯，涵盖影视剧介绍、人物资料和用户互动讨论，满足多样娱乐需求。",
    keywords: "巨乳,娱乐资讯,影视人物,网络话题,影视聚合,明星资料,热门讨论",
  });

  const latestFilms = [...films]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, 6);
  const hotTopics = topics.slice(0, 4);
  const featuredStars = stars.slice(0, 5);

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-6 md:px-8 md:py-8">
      <div className="mb-5 flex flex-col gap-1">
        <h1 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          巨乳娱乐资讯网 · 影视人物及话题聚合平台
        </h1>
        <p className="text-sm text-foreground-500">
          聚焦影视作品、明星人物与网络热门话题，聚合你关心的娱乐资讯。
        </p>
      </div>

      <HeroCarousel />

      <section className="mt-6 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
        {siteStats.map((stat) => (
          <div
            key={stat.label}
            className="flex flex-col gap-1 rounded-lg border border-background-200 bg-background-50 p-4"
          >
            <span className="font-heading text-xl font-bold text-primary-600 md:text-2xl">
              {stat.value}
            </span>
            <span className="text-xs text-foreground-500">{stat.label}</span>
          </div>
        ))}
      </section>

      <div className="mt-8 grid grid-cols-1 gap-8 lg:grid-cols-3">
        <div className="flex flex-col gap-10 lg:col-span-2">
          <section>
            <SectionHeading
              title="最新影视作品推荐"
              subtitle="按更新时间为你整理的最新剧集与电影"
              moreTo="/category/films"
            />
            <div className="grid grid-cols-2 gap-4 md:grid-cols-3">
              {latestFilms.map((film) => (
                <FilmCard key={film.id} film={film} />
              ))}
            </div>
          </section>

          <section>
            <SectionHeading
              title="网络热门话题"
              subtitle="正在被讨论的娱乐焦点"
              moreTo="/category/topics"
            />
            <div className="flex flex-col gap-3">
              {hotTopics.map((topic) => (
                <TopicCard key={topic.id} topic={topic} variant="row" />
              ))}
            </div>
          </section>
        </div>

        <aside className="flex flex-col gap-6">
          <HotTagCloud />

          <section className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
            <SectionHeading title="明星人物推荐" moreTo="/category/stars" />
            <div className="flex flex-col gap-3">
              {featuredStars.map((star) => (
                <Link
                  key={star.id}
                  to={`/detail/star/${star.id}`}
                  className="group flex items-center gap-3"
                >
                  <span className="h-11 w-11 shrink-0 overflow-hidden rounded-full bg-background-100">
                    <img
                      src={star.avatar}
                      alt={`${star.name} 头像`}
                      title={`${star.name} 明星人物 巨乳娱乐资讯网`}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                  <span className="flex min-w-0 flex-col">
                    <span className="text-sm font-medium text-foreground-900 group-hover:text-primary-600">
                      {star.name}
                    </span>
                    <span className="line-clamp-1 text-xs text-foreground-500">
                      代表作：{getStarFilms(star).map((f) => f.title).join("、")}
                    </span>
                  </span>
                </Link>
              ))}
            </div>
          </section>

          <section className="rounded-lg border border-background-200 bg-accent-50 p-4 md:p-5">
            <h3 className="flex items-center gap-2 text-base font-bold text-foreground-950">
              <i className="ri-compass-3-line text-accent-600" aria-hidden="true"></i>
              推荐专题
            </h3>
            <p className="mt-2 text-xs leading-relaxed text-foreground-600">
              从作品出发，串联演员、幕后与舆论讨论，快速进入你关心的娱乐话题。
            </p>
            <div className="mt-3 flex flex-wrap gap-2">
              <Link
                to="/category/films"
                className="whitespace-nowrap rounded-full bg-primary-500 px-3 py-1 text-xs text-background-50 transition-colors hover:bg-primary-600"
              >
                影视作品库
              </Link>
              <Link
                to="/category/stars"
                className="whitespace-nowrap rounded-full bg-secondary-500 px-3 py-1 text-xs text-background-50 transition-colors hover:bg-secondary-600"
              >
                明星人物库
              </Link>
              <Link
                to="/category/topics"
                className="whitespace-nowrap rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50 transition-colors hover:bg-accent-600"
              >
                热门话题榜
              </Link>
            </div>
          </section>
        </aside>
      </div>

      <div className="mt-10">
        <SiteIntroBanner />
      </div>
    </div>
  );
}